import React, { useRef, useState } from "react";
import "./styles/index.scss";
import Navbar from "./components/Nav";
import Main from "./components/Main";
import History from "./components/History";
import ProductContent from "./components/ProductContent.jsx";
import Sustainability from "./components/Sustainability.jsx";
import Subscribe from "./components/Subscribe.jsx";
import Captcha from "./components/Captcha.jsx";

function App() {
  const [captchaValue, setCaptchaValue] = useState(null);
  const captchaRef = useRef(null);

  console.log("🚀TCL ~ App ~ captchaValue:", captchaValue);
  const handleCaptchaChange = (val) => {
    setCaptchaValue(val);
  };
  return (
    <div className={`app ${!!captchaValue ? "" : "blocked"}`}>
      <Captcha showCaptcha={!captchaValue} ref={captchaRef} handleCaptchaChange={handleCaptchaChange} />
      <Navbar />
      <Main />
      <History />
      <ProductContent />
      <Sustainability />
      <Subscribe showContact={!!captchaValue} />
    </div>
  );
}

export default App;
